import React from 'react';
import { Task } from 'make-traffic-integration-core';
import {
  FlexRow,
  filterTasksByPlatform,
  getTaskIconUrl,
  TaskButton,
  TaskCard
} from '@make-software/tg-mini-app-ui';

import GoldIcon from '@/shared/assets/icons/gold.svg';
import { useSeasonInfo } from '@/shared';

interface TaskListProps {
  tasks: Task[];
  friendCount?: number;
  onTaskClick: (t: Task) => void;
  disabledPredicate?: (t: Task) => boolean;
  bottomMargin?: string;
}

export const TaskList: React.FC<TaskListProps> = ({ tasks, friendCount, onTaskClick, bottomMargin }) => {
  if (!tasks.length) return null;

  const filteredTasks = filterTasksByPlatform(tasks);
  const { data: seasonInfo } = useSeasonInfo();
  const isSeasonEnded = new Date() > new Date(seasonInfo?.season?.ends_on || '2026-07-26T23:59:59Z');

  return (
    <FlexRow
      gap={8}
      direction="column"
      style={bottomMargin ? { marginBottom: bottomMargin } : undefined}
    >
      {filteredTasks.map((t) => {
        return (
          <TaskCard
            key={t.id}
            task={t}
            iconUrl={getTaskIconUrl(t, (window as any)?.config?.assets_path)}
            rewardLabel="Earn:"
            borderRadius="8px"
            border="1px solid #41424e"
            background="#30313b"
            titleFont={{ fontFamily: 'Inter' }}
            rewardLabelFont={{
              fontFamily: 'Inter',
              fontWeight: '400',
              color: '#a9aaad !important'
            }}
            rewardsProps={{
              earnIconSrc: GoldIcon,
              earnIconColor: 'auto',
              rewardIcons: {
                points: window.config.assets_path + '/gold.svg',
                plays: window.config.assets_path + '/fantom-run.svg'
              },
              iconSize: 15,
              valueFont: {
                fontFamily: 'JetBrains Mono',
                fontWeight: 700,
                fontSize: '14px'
              }
            }}
            actionButton={(t) => (
              <TaskButton
                task={t}
                disabled={isSeasonEnded}
                friendCount={friendCount}
                goButtonVariant="outlined"
                width={48}
                onClick={() => onTaskClick(t)}
                doneButton={{ fontFamily: 'Inter', fontSize: '12px', fontWeight: 400 }}
                goButton={{ fontFamily: 'Inter', fontSize: '12px', fontWeight: 400 }}
              />
            )}
          />
        );
      })}
    </FlexRow>
  );
};
